import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "common/stylus/common.styl";
import api from "common/js/data";
import 'vue2-toast/lib/toast.css'
import Toast from 'vue2-toast'

Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(Toast)
Vue.prototype.$api = api; // 给vue 添加的新的属性$api

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
